
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/print-data-delivery",
      function () {
        return require("private-next-pages/print-data-delivery.tsx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/print-data-delivery"])
      });
    }
  